import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "contestdream.twitter.icon",
  "use": "contestdream.twitter.icon-usage",
  "viewBox": "-928 -13886 64 84.001",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-928 -13886 64 84.001\" id=\"contestdream.twitter.icon\"><g data-name=\"Group 981\" fill=\"currentColor\"><path data-name=\"Subtraction 148\" d=\"M63.733,83.61h-64v-84h64v84Zm-61-81v78h58v-78Z\" transform=\"translate(-927.732 -13885.609)\" /><path d=\"M60.091,21.3a16.6,16.6,0,0,1-6,2h0c-1.613-1.685-3.481-2-6-2a9.1,9.1,0,0,0-9,9,9.187,9.187,0,0,0,0,2h0c-6.636-.174-13.631-4.308-18-10-2.686,4.649-1.048,10.116,2,12a3.662,3.662,0,0,1-3-1c-.061,3.086.59,7.517,6,9-1.042.561-2.2.119-3,0,.281,2.605,4.011,6,8,6-1.422,1.645-7,4.949-13,4a27.193,27.193,0,0,0,14,4,24.884,24.884,0,0,0,25-26c0-.016,0,.017,0,0,0-.037,0,.038,0,0s0-.957,0-1a12.238,12.238,0,0,0,4-4,18.691,18.691,0,0,1-5,1,10.414,10.414,0,0,0,4-5\" transform=\"translate(-935.091 -13882.297)\" fill-rule=\"evenodd\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/contestdream.twitter.icon.svg
// module id = flok
// module chunks = 13